<template functional>
    <b-button 
        :variant="props.buttonVariant" 
        :href="props.fileData.download_url" 
        class="p-0 file-download-badge"
        target="_blank"
    >
        <div class="d-flex align-items-center text-left">
            <div 
                :class="props.hideFilesize ? 'px-1' : 'px-2'"
                class="h-100 py-1 d-flex justify-content-center align-items-center"
            >    
                <span 
                    :title="props.fileData.filename" 
                    :class="['fiv-sqo fiv-icon-' + props.fileData.file_extension, props.hideFilesize ? 'font-size-100' : 'font-size-150']"
                ></span>
            </div>
            <div class="h-100 py-1 px-2 font-size-80">
                <div>{{ props.showTitle ? props.fileData.title : props.fileData.filename }}</div>
                <div v-if="!props.showTitle" class="small text-muted"></div>
                <div v-if="!props.hideFilesize" class="small text-muted">{{ props.fileData.filesize | formatFileSize }}</div>
            </div>
            <div 
                v-if="!props.hideDownloadIcon"
                class="h-100 py-1 px-2 d-flex justify-content-center align-items-center"
            >
                <b-icon icon="download" :font-scale="props.hideFilesize ? '1' : '1.5'"></b-icon>
            </div>
        </div>
    </b-button>
</template>

<script>
import { FormatFileSizeHelper } from '../../js/filters-helpers'

export default {
    functional: true,
    name: 'FileDownloadBadge',
    props: {
        fileData: {  // assumes object from your standard S3File serializer -- you need at least: 'filename', 'download_url' and 'filesize'
            type: Object,
            required: true,
        },
        showTitle: {  // set to true to show title in prominent position, filename below.  False means no title shown.
            type: Boolean,
            default: false,
        },
        buttonVariant: {
            type: String,
            default: 'minimal-primary',
        },
        hideFilesize: {  // if set, it hides filesize and renders a smaller file icon to make overall button smaller
            type: Boolean,
            default: false,
        },
        hideDownloadIcon: {  // if true, hide the download icon on right side
            type: Boolean,
            default: false,
        }
    },
    filters: {
        formatFileSize: function(value) {
            return FormatFileSizeHelper(value);
        }
    }
}
</script>

<style lang="scss">

</style>